import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  // Inject Router at the top level of the interceptor function
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Determine error type
      let errorType: 'network' | 'server' | 'unknown' = 'unknown';
      
      // Check for network errors (status 0 typically means network failure)
      if (error.status === 0 || 
          error.message?.toLowerCase().includes('network') ||
          error.message?.toLowerCase().includes('failed to fetch') ||
          error.message?.toLowerCase().includes('internet')) {
        errorType = 'network';
      }
      // Check for server errors (5xx)
      else if (error.status >= 500 && error.status < 600) {
        errorType = 'server';
      }
      // Check for timeout errors
      else if (error.status === 408 || error.message?.toLowerCase().includes('timeout')) {
        errorType = 'network';
      }

      // Only redirect for true network failures (status 0). Server 5xx and 4xx are handled
      // by the calling screen (e.g. program form error modal), not the global error page.
      if (errorType === 'network') {
        
        // Navigate to error page with error details
        // Use setTimeout to avoid navigation during error handling
        setTimeout(() => {
          router.navigate(['/error'], {
            state: { error: error }
          }).catch(() => {
            // If navigation fails, try direct navigation
            window.location.href = '/error';
          });
        }, 0);
      }

      // Re-throw the error so components can still handle it if needed
      return throwError(() => error);
    })
  );
};

